// Vue
import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
// Template
import template from './template.vue'
import {ContentArea} from "../content_area/ContentArea";
import {DashboardTile} from "../../../interfaces/DashboardTile";
import {DashboardTile as MgsDashboardtile} from '../dashboard_tile/DashboardTile'
import {HttpService} from "../../../services/HttpService";

@Component({
    mixins: [template],
    components: {
        ContentArea,
        MgsDashboardtile
    }
})
export class HeaderFavorites extends Vue {

    private readonly http: HttpService = HttpService.instance

    @Prop()
    public lang!: string

    @Prop()
    public country!: string;

    public isLoading = false

    public favorites: DashboardTile[] = []

    private favoritesLimit = 4;

    public mounted()
    {
        if (this['$eventBus']) {
            (this['$eventBus'] as Vue).$on('cms.favorites.added', this.favoritesAdded);
            (this['$eventBus'] as Vue).$on('cms.favorites.removed', this.favoritesRemoved);
        }
    }

    public beforeDestroy()
    {
        if (this['$eventBus']) {
            (this['$eventBus'] as Vue).$off('cms.favorites.added', this.favoritesAdded);
            (this['$eventBus'] as Vue).$off('cms.favorites.removed', this.favoritesRemoved);
        }
    }

    private async favoritesAdded() {
        await this.getTiles();
    }

    private async favoritesRemoved() {
        await this.getTiles();
    }

    created() {
        this.getTiles();
    }

    public async getTiles() {
        this.isLoading = true;

        this.favorites = await this.getFavorites();

        this.isLoading = false;
    }

    get finalFavorites() {
        return this.favorites.slice(0, this.favoritesLimit);
    }

    get emptyFavorites() {
        return this.favoritesLimit - this.finalFavorites.length;
    }

    public async toggleFavoriteFlag(tile) {
        if( tile['isFavorite']) {
            await this.removeFavorite(tile['id']);
            this.favorites = this.favorites.filter(t => t.id != tile.id)

            if (this['$eventBus']) {
                (this['$eventBus'] as Vue).$emit('cms.favorites.removed', tile['id']);
            }
        }
    }

    public async getFavorites(): Promise<Array<DashboardTile>> {
        let queryUrl = `${APP_API_URL}cms/${this.lang}/${this.country}/27/kacheln`;

        const response = await this.http.get<Array<DashboardTile>>(queryUrl, {
            params: {
                favorites: 1
            }
        });

        return response.body!
    }

    public async removeFavorite(tileId) {
        let url = `${APP_API_URL}cms/${this.lang}/${this.country}/favorites`;
        const response = await this.http.delete<any>(url + `/${tileId}` );

        return response.body!
    }
}
